/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-confusing-browser-globals */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { useEffect } from 'react';
import { useThrottledFunc } from './customHooks';
import { getQueryParams, stringifyQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';

const setQueryParams = updatedParams => {
  const newQueryString = stringifyQueryParams(Object.assign({}, getQueryParams(), {}, updatedParams));
  const newUrl = `${window.location.pathname}?${newQueryString}`;
  history.replaceState(history.state, '', newUrl);
};

export const useQueryParamsEffect = params => {
  const throttledSetQueryParams = useThrottledFunc(setQueryParams, 300);
  useEffect(() => {
    throttledSetQueryParams(params);
  }, [params]);
};